var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class HallResearchSc {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'R POWER',
                next: /POWER|[=]{6,}/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('ST', /FW[\s:]*(?:Version:)?([\d\.]+)/i, tags);
                return match[1];
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`R POWER`, /POWER\s(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                this.state.busy.update(true);
                const match = yield this.socket.send(`S POWER ${power ? '1' : '0'}`, /POWER\s(\d)/i, tags);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 3500 : 2000);
                if (power)
                    this.framework.suspend(3000);
                return match[1] === '1';
            }),
            asyncHandlers: {
                regExp: /(PONOK|Power Off|System Initial Ok)/i,
                callback: (match) => {
                    this.state.power.update(match[1] !== 'Power Off');
                },
            },
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`R SOURCE`, /SOURCE\s(\d+)/i, tags);
                return match[1];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`S SOURCE ${value}`, /S SOURCE\s(\d+)/i, tags);
                return match[1];
            }),
            powerOffRestrictions: ['set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`R VOLUME`, /VOLUME (\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`S VOLUME ${volume}`, /S VOLUME (\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            range: { max: 100, min: 0, round: 1 },
            powerOffRestrictions: ['set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`R AUDIO MUTE`, /AUDIO MUTE (\d)/i, tags);
                return match[1] === '1';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`S AUDIO MUTE ${mute ? '1' : '0'}`, /S AUDIO MUTE (\d)/i, tags);
                return match[1] === '1';
            }),
            powerOffRestrictions: ['set'],
        };
        // polling
        this.polls = [{ intervalMs: 2500, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
HallResearchSc.driverType = 'socketDriver';
HallResearchSc.key = '-LStmN9BU56TIkMbOC_u';
HallResearchSc.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r\n',
};
HallResearchSc.socketOptions = [
    Object.assign(Object.assign({}, HallResearchSc.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, HallResearchSc.baseSocketOptions), { port: 4999 }),
];
